<template lang="pug">
.v-about.about(v-if="data")
	.container
		h1.about-title(v-if="data.title" ) {{ data.title }}
		p.about-body(v-if="data.text" v-html="data.text")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [sourceMixin],

	data() {
		return {
			data: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>